'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_ALIASES = undefined;

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_ALIASES = exports.ICON_ALIASES = {
  'align-center': _icons2.default.ALIGNCENTER,
  'align-justify': _icons2.default.ALIGNJUSTIFY,
  'align-left': _icons2.default.ALIGNLEFT,
  'align-right': _icons2.default.ALIGNRIGHT,
  'angle-double-left': _icons2.default.PREVIOUS,
  'angle-double-right': _icons2.default.NEXT,
  'angle-left': _icons2.default.LEFT,
  'angle-right': _icons2.default.RIGHT,
  'building-o': _icons2.default.COMPANIES,
  calendar: _icons2.default.DATE,
  call: _icons2.default.CALLING,
  chain: _icons2.default.LINK,
  check: _icons2.default.SUCCESS,
  check2: _icons2.default.SUCCESS,
  clock: _icons2.default.TIME,
  clock2: _icons2.default.TIME,
  close: _icons2.default.REMOVE,
  'cloud-upload': _icons2.default.UPLOAD,
  'clear-formatting': _icons2.default.ERASESTYLES,
  'comment-o': _icons2.default.COMMENTS,
  'comments-o': _icons2.default.COMMENTS,
  contact: _icons2.default.CONTACTS,
  contacts2: _icons2.default.CONTACTS,
  copy: _icons2.default.DUPLICATE,
  cross2: _icons2.default.REMOVE,
  'cta-click': _icons2.default.CTAS,
  deal: _icons2.default.DEALS,
  dedent: _icons2.default.OUTDENT,
  document: _icons2.default.DOCUMENTS,
  'down-angle': _icons2.default.DOWN,
  'down-arr': _icons2.default.DOWN,
  'email-open': _icons2.default.EMAILOPEN,
  embed2: _icons2.default.CODE,
  eraser: _icons2.default.ERASESTYLES,
  'external-link': _icons2.default.EXTERNALLINK,
  eye: _icons2.default.VIEW,
  'eye-slash': _icons2.default.HIDE,
  'file-text': _icons2.default.FILE,
  'folder-open': _icons2.default.FOLDEROPEN,
  form: _icons2.default.FORMS,
  gear: _icons2.default.SETTINGS,
  hamburger: _icons2.default.LISTVIEW,
  handshake: _icons2.default.DEALS,
  'help-with-circle': _icons2.default.INFO,
  layer: _icons2.default.HUBDB,
  'left-angle': _icons2.default.LEFT,
  'left-arr': _icons2.default.LEFT,
  'left-arrow': _icons2.default.PREVIOUS,
  'list-ol': _icons2.default.NUMBERLIST,
  'list-ul': _icons2.default.BULLETLIST,
  lock: _icons2.default.LOCKED,
  mail: _icons2.default.EMAIL,
  'mail-dark': _icons2.default.EMAIL,
  microphone: _icons2.default.RECORD,
  newspaper: _icons2.default.BLOG,
  pen: _icons2.default.SIGNATURE,
  pencil: _icons2.default.EDIT,
  phone: _icons2.default.CALLING,
  photo: _icons2.default.INSERTIMAGE,
  plus: _icons2.default.ADD,
  'price-tag': _icons2.default.TAG,
  'quotes-left': _icons2.default.INSERTQUOTE,
  'right-angle': _icons2.default.RIGHT,
  'right-arr': _icons2.default.RIGHT,
  'right-arrow': _icons2.default.NEXT,
  star: _icons2.default.FAVORITE,
  'star-o': _icons2.default.FAVORITE,
  trash: _icons2.default.DELETE,
  trash2: _icons2.default.DELETE,
  'up-arr': _icons2.default.UP,
  'up-angle': _icons2.default.UP,
  'upload-dark': _icons2.default.UPLOAD,
  'upload-light': _icons2.default.UPLOAD,
  user: _icons2.default.CONTACTS,
  'volume-down': _icons2.default.VOLUMEDOWN,
  'volume-up': _icons2.default.VOLUMEUP,
  'volume-off': _icons2.default.VOLUMEMUTE,
  'warning-triangle': _icons2.default.WARNING,
  x: _icons2.default.REMOVE,
  'zoom-in': _icons2.default.ZOOMIN,
  'zoom-out': _icons2.default.ZOOMOUT,

  // social icons
  'youtube-play': _icons2.default.SOCIALYOUTUBEPLAY,
  'youtube': _icons2.default.SOCIALYOUTUBE,
  'xing': _icons2.default.SOCIALXING,
  'twitter': _icons2.default.SOCIALTWITTER,
  'pinterest': _icons2.default.SOCIALPINTEREST,
  'linkedin': _icons2.default.SOCIALLINKEDIN,
  'google': _icons2.default.SOCIALGOOGLE,
  'google-drive': _icons2.default.SOCIALGOOGLEDRIVE,
  'google-drive2': _icons2.default.SOCIALGOOGLEDRIVE,
  'google-plus': _icons2.default.SOCIALGOOGLEPLUS,
  'google-plus2': _icons2.default.SOCIALGOOGLEPLUS,
  'facebook': _icons2.default.SOCIALFACEBOOK,
  'block-youtube-play': _icons2.default.SOCIALBLOCKYOUTUBEPLAY,
  'block-youtube': _icons2.default.SOCIALBLOCKYOUTUBE,
  'block-xing': _icons2.default.SOCIALBLOCKXING,
  'block-twitter': _icons2.default.SOCIALBLOCKTWITTER,
  'block-rss': _icons2.default.SOCIALBLOCKRSS,
  'block-pinterest': _icons2.default.SOCIALBLOCKPINTEREST,
  'block-linkedin': _icons2.default.SOCIALBLOCKLINKEDIN,
  'block-google-plus': _icons2.default.SOCIALBLOCKGOOGLEPLUS,
  'block-facebook': _icons2.default.SOCIALBLOCKFACEBOOK,
  'rss': _icons2.default.SOCIALRSS
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/icon/IconAliases.js
// module id = 134
// module chunks = 0 1